module.exports = __webpack_public_path__ + "assets/img/alipay.bca74b8b.svg";